import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex"} }
const _hoisted_2 = ["src", "onClick"]
const _hoisted_3 = { style: {"padding":"20px"} }

import { layer } from "@layui/layui-vue"
import { reactive, h, resolveComponent,ref } from 'vue'

import { getSecondaryCities } from "../../utils/secondaryCities";

import { allProcessFengLou ,reviewFengLou} from '../../api'



export default /*#__PURE__*/_defineComponent({
  __name: 'process',
  setup(__props) {
 
const search = reactive({
  key: "", 
  keyword: "",
  type: "0"

})

//地区联动
const options = getSecondaryCities();



const loading = ref(false);

const selectedKeys = ref([]);

const page = reactive({ current: 1, limit: 10, total: 0 });
const dataSource = ref([]);

const columns = ref([
  { title:"选项", width: "55px", type: "checkbox", fixed: "left" },
  { title: "平台", width: "120px", key: "platformId", align: "center" },
  { title: "账号", width: "120px", key: "userName", align: "center" },
  { title: "审核状态", width: "150px", key: "type", align: "center", customSlot: "type" }, 
  { title: "图片", width: "150px", key: "imgs", align: "center", customSlot: "imgs" },
  { title: "标题", width: "150px", key: "title", align: "center" },
  { title: "价格", width: "80px", key: "price", align: "center" },
  { title: "年龄", width: "80px", key: "age", align: "center" },
  { title: "颜值", width: "80px", key: "appearance", align: "center" },
  { title: "服务项目", width: "80px", key: "serviceItems", align: "center" },
  { title: "地区", width: "120px", key: "area", align: "center" },
  { title: "地址", width: "120px", key: "address", align: "center" },
  { title: "手机", width: "80px", key: "phone", align: "center" },
  { title: "qq", width: "80px", key: "qq", align: "center" },
  { title: "微信", width: "80px", key: "weChat", align: "center" },
  { title: "飞机", width: "80px", key: "plain", align: "center" },
  { title: "简介", key: "summary", align: "center" },
  { title: "说明", key: "remark", align: "center" },

  { title: "添加时间", width: "120px", key: "addTime", align: "center" }
]);




const getProcessFengLou = () => {
  var province = "";
  var city = "";
  if (search.keyword != null && search.keyword.includes("/")) {
    var provincelist = search.keyword.split("/")
    province = provincelist[0];
    city = provincelist[1];
  } else {
    province = search.keyword;
  }

  loading.value = true;
  var data = { "page": page.current, "limit": page.limit, "key": search.key, "type": search.type, "province": province, "city": city };
  allProcessFengLou(JSON.stringify(data)).then((res: any) => {
    loading.value = false;
    if (res != "" && res.code == 0) {
      dataSource.value = [];
      var fengLouList = res.data;
      for (var i = 0; i < fengLouList.length; i++) {
        fengLouList[i].area = getProvince(fengLouList[i].province, fengLouList[i].city);
      }


      dataSource.value = res.data;
      page.total = res.count;
    } else {
      dataSource.value = [];
      page.total = 0;
    }
  })

}


getProcessFengLou();
const change = (page:any) => {
  getProcessFengLou();
}

const sortChange = (key:any, sort:any) => {
  layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
}



//获取地区 
const getProvince = (province: any, city: any) => {
  var provinceStr = "";
  if (province != null) {
    for (var i = 0; i < options.length; i++) {
      if (options[i].value == province) {
        provinceStr = options[i].label;
        break;
      }
    }
  }
  if (city != null) {
    for (var i = 0; i < options.length; i++) {
      if (options[i].value == province) {
        var list = options[i].children;
        for (var j = 0; j < list.length; j++) {
          if (list[j].value == city) {
            provinceStr = provinceStr + "/" + list[j].label;
            break;
          }

        }


      }
    }
  }
   return provinceStr; 
}

//查询
const  searchFengLou=()=>{
  getProcessFengLou();
}

//查看图片

const signleImg = (imgur: any) => {
  layer.photos({
    imgList: [{ src: imgur }]
  })
}

//状态
 
const changeType = (row: any, value: any) => {
  selectedId.value.push(row.id) 
  if(value==2){
    visible11.value = !visible11.value; 
  }else{
    var  data = { "key": value, "list": selectedId.value };
    addReviewFengLou(JSON.stringify(data))
  } 
}

 

const selectedId = ref([]);

const selectedFengLou=(num:any)=>{
  selectedId.value=selectedKeys.value; 
  if(num==1){
    var  data = { "key": "1", "list": selectedId.value };
     addReviewFengLou(JSON.stringify(data))
  }else{
 
    visible11.value = !visible11.value; 
  }

  



}

const addReviewFengLou=(data:any)=>{

  reviewFengLou(data).then((res: any) => {
     
    if (res != "" && res.code == 0) {

      layer.msg("操作成功", { icon : 1, time: 1000})
      getProcessFengLou();
    } else {
      layer.msg(res.msg, { icon : 2, time: 1000})
    }
  })

}


const remark =ref("");

const visible11 = ref(false);

const action11 = ref([
    {
        text: "确认",
        callback: () => {  
          var  data = { "key": "2", "list": selectedId.value,"keyword": remark.value}; 
          addReviewFengLou(JSON.stringify(data)) 
          visible11.value = !visible11.value;
        }
    },
    {
        text: "取消",
        callback: () => {
          visible11.value = !visible11.value;
        }
    }
])


return (_ctx: any,_cache: any) => {
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_select_option = _resolveComponent("lay-select-option")!
  const _component_lay_select = _resolveComponent("lay-select")!
  const _component_lay_cascader = _resolveComponent("lay-cascader")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!
  const _component_lay_textarea = _resolveComponent("lay-textarea")!
  const _component_lay_layer = _resolveComponent("lay-layer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_lay_row, { space: "10" }, {
      default: _withCtx(() => [
        _createVNode(_component_lay_col, { md: "24" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, null, {
              default: _withCtx(() => [
                _createVNode(_component_lay_form, {
                  model: search,
                  style: {"text-align":"start"},
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lay_form_item, {
                      label: "搜索",
                      prop: "key",
                      mode: "inline"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_input, {
                          modelValue: search.key,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.key) = $event)),
                          placeholder: "请输入标题"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, {
                      label: "状态",
                      prop: "type",
                      mode: "inline"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_select, {
                          modelValue: search.type,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search.type) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_select_option, {
                              value: "0",
                              label: "全部"
                            }),
                            _createVNode(_component_lay_select_option, {
                              value: "1",
                              label: "待审核"
                            }),
                            _createVNode(_component_lay_select_option, {
                              value: "2",
                              label: "审核失败"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, {
                      label: "地区",
                      prop: "keyword",
                      mode: "inline"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_cascader, {
                          options: _unref(options),
                          modelValue: search.keyword,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((search.keyword) = $event)),
                          changeOnSelect: true,
                          "allow-clear": "",
                          placeholder: "选择地区"
                        }, null, 8, ["options", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, { mode: "inline" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_button, {
                          type: "primary",
                          size: "sm",
                          onClick: searchFengLou
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("查询")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"]),
                _createVNode(_component_lay_table, {
                  page: page,
                  height: '100%',
                  "default-toolbar": false,
                  resize: false,
                  columns: columns.value,
                  loading: loading.value,
                  "data-source": dataSource.value,
                  "selected-keys": selectedKeys.value,
                  "onUpdate:selectedKeys": _cache[5] || (_cache[5] = ($event: any) => ((selectedKeys).value = $event)),
                  onChange: change,
                  onSortChange: sortChange
                }, {
                  toolbar: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(_component_lay_button, {
                        size: "sm",
                        type: "primary",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (selectedFengLou(1)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("通过")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_lay_button, {
                        size: "sm",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (selectedFengLou(2)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("失败")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  type: _withCtx(({ row }) => [
                    _createVNode(_component_lay_select, {
                      modelValue: row.type,
                      "onUpdate:modelValue": ($event: any) => ((row.type) = $event),
                      placeholder: "请选择"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_select_option, {
                          value: 0,
                          onClick: ($event: any) => (changeType(row, row.type)),
                          label: "待审核"
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_lay_select_option, {
                          value: 1,
                          onClick: ($event: any) => (changeType(row, row.type)),
                          label: "通过审核"
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_lay_select_option, {
                          value: 2,
                          onClick: ($event: any) => (changeType(row, row.type)),
                          label: "审核失败"
                        }, null, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  imgs: _withCtx(({ row }) => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.imgs.split(','), (img) => {
                      return (_openBlock(), _createElementBlock("img", {
                        src: img,
                        onClick: ($event: any) => (signleImg(img)),
                        style: {"width":"40px"}
                      }, null, 8, _hoisted_2))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_lay_layer, {
      modelValue: visible11.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((visible11).value = $event)),
      shade: false,
      area: ['500px', '450px'],
      btn: action11.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_lay_form, {
            model: remark.value,
            ref: "layFormRef11"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form_item, {
                label: "说明",
                prop: "desc"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_textarea, {
                    placeholder: "请输入说明",
                    modelValue: remark.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((remark).value = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"])
  ], 64))
}
}

})